import { Plus, Trash2, Star } from "lucide-react";

const btn = "shrink-0 h-9 w-9 flex items-center justify-center rounded-md border transition-colors";

// Più indirizzi email/PEC: il preferito resta nel campo principale (usato di default per gli invii), gli altri in `extra`.
export default function MultiEmail({ value, extra, onChange, testId, label = "email", type = "email", star = true, altLabel, renderAfter }) {
  const list = [value || "", ...(Array.isArray(extra) ? extra : [])];
  const emit = (l) => onChange(l[0] || "", l.slice(1));
  const setAt = (i, v) => emit(list.map((x, j) => (j === i ? v : x)));
  const prefer = (i) => emit([list[i], ...list.filter((_, j) => j !== i)]);
  const remove = (i) => { const l = list.filter((_, j) => j !== i); emit(l.length ? l : [""]); };
  return (
    <div className="mt-1.5 space-y-1.5" data-testid={`${testId}-multi`}>
      {list.map((v, i) => (
        <div key={i} className="flex items-center gap-1.5">
          <input type={type} value={v} onChange={(e) => setAt(i, e.target.value)} data-testid={i === 0 ? testId : `${testId}-${i}`}
            placeholder={i === 0 ? "" : (altLabel || `Altra ${label}`)}
            className="h-9 flex-1 min-w-0 rounded-md border border-slate-700 bg-slate-900/60 px-3 text-sm text-slate-100" />
          {renderAfter && <span className="shrink-0 w-7 flex items-center justify-center">{(v || "").trim() ? renderAfter(v.trim(), i) : null}</span>}
          {star && list.length > 1 && (
            <button type="button" onClick={() => i && prefer(i)} aria-pressed={i === 0} data-testid={`${testId}-star-${i}`}
              title={i === 0 ? `${label} preferita: usata di default per l'invio` : `Imposta come ${label} preferita`}
              className={`${btn} ${i === 0 ? "border-amber-500/60 text-amber-500 bg-amber-500/10" : "border-slate-600 text-slate-500 hover:text-amber-500"}`}>
              <Star className="h-4 w-4" fill={i === 0 ? "currentColor" : "none"} />
            </button>
          )}
          {i === 0 ? (
            <button type="button" onClick={() => emit([...list, ""])} title={`Aggiungi ${altLabel || `un'altra ${label}`}`} data-testid={`${testId}-add`}
              className={`${btn} border-emerald-600/60 text-emerald-400 hover:bg-emerald-500/10`}><Plus className="h-4 w-4" /></button>
          ) : <span className="shrink-0 w-9" aria-hidden="true" />}
          {list.length > 1 && (
            <button type="button" onClick={() => remove(i)} title={`Elimina questa ${label}`} data-testid={`${testId}-del-${i}`}
              className={`${btn} border-red-600/50 text-red-400 hover:bg-red-500/10`}><Trash2 className="h-4 w-4" /></button>
          )}
        </div>
      ))}
    </div>
  );
}
